var productCardMarkup = 
    
  `<div class="popular-products collection-page-pro">
<div class="popular-products-wrap collction_grid">
<div class="collection_grid_wrapper popular-products-slider">
<div class="swym-wishlist-grid">
		{{#products}} 
	<div class="slide">
    <div class="slide-wrap">

		<button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span></button>

      <div class="slide-image">
		<div class="image-wrap">
      		<a href="{{du}}">
			  <img src="{{iu}}" alt="">
			</a>
		</div>

		<button class="mini-cart-viewicon" data-href="{{ du }}?view=qv">
        	<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white"/> <path d="M35.2047 23.745C34.3226 21.4632 32.7912 19.49 30.7998 18.0691C28.8084 16.6482 26.4443 15.8419 23.9997 15.75C21.5551 15.8419 19.191 16.6482 17.1996 18.0691C15.2082 19.49 13.6768 21.4632 12.7947 23.745C12.7351 23.9098 12.7351 24.0902 12.7947 24.255C13.6768 26.5368 15.2082 28.51 17.1996 29.9309C19.191 31.3518 21.5551 32.1581 23.9997 32.25C26.4443 32.1581 28.8084 31.3518 30.7998 29.9309C32.7912 28.51 34.3226 26.5368 35.2047 24.255C35.2643 24.0902 35.2643 23.9098 35.2047 23.745ZM23.9997 30.75C20.0247 30.75 15.8247 27.8025 14.3022 24C15.8247 20.1975 20.0247 17.25 23.9997 17.25C27.9747 17.25 32.1747 20.1975 33.6972 24C32.1747 27.8025 27.9747 30.75 23.9997 30.75Z" fill="#0F1F2E"/> <path d="M24 19.5C23.11 19.5 22.24 19.7639 21.4999 20.2584C20.7599 20.7529 20.1831 21.4557 19.8425 22.2779C19.5019 23.1002 19.4128 24.005 19.5865 24.8779C19.7601 25.7508 20.1887 26.5526 20.818 27.182C21.4474 27.8113 22.2492 28.2399 23.1221 28.4135C23.995 28.5872 24.8998 28.4981 25.7221 28.1575C26.5443 27.8169 27.2471 27.2401 27.7416 26.5001C28.2361 25.76 28.5 24.89 28.5 24C28.5 22.8065 28.0259 21.6619 27.182 20.818C26.3381 19.9741 25.1935 19.5 24 19.5ZM24 27C23.4067 27 22.8266 26.8241 22.3333 26.4944C21.8399 26.1648 21.4554 25.6962 21.2284 25.1481C21.0013 24.5999 20.9419 23.9967 21.0576 23.4147C21.1734 22.8328 21.4591 22.2982 21.8787 21.8787C22.2982 21.4591 22.8328 21.1734 23.4147 21.0576C23.9967 20.9419 24.5999 21.0013 25.1481 21.2284C25.6962 21.4554 26.1648 21.8399 26.4944 22.3333C26.8241 22.8266 27 23.4067 27 24C27 24.7957 26.6839 25.5587 26.1213 26.1213C25.5587 26.6839 24.7957 27 24 27Z" fill="#0F1F2E"/> <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#F1F2F4"/> </svg>
      	</button>

		<div class="products-hover-cart-btn">
            <form method="post" action="/cart/add" class="product-form is_grid no_ro_widget" enctype="multipart/form-data" novalidate="novalidate">
              <div class="div-wrap">
                <input type="hidden" name="form_type" value="product">
                <input type="hidden" name="utf8" value="✓">
                <input type="hidden" name="id" value="{{epi}}">
                <input type="hidden" name="quantity" value="1">
                <button name="add" onclick="pintrk('track', 'addtocart');" class="btn buttonAddtoCart">Add to Cart</button>
              </div>
              <div class="in_cart">
                <span class="text">In cart</span>
                <span class="icon_true">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20.081 6.07608L20.0798 6.07733L9.99817 16.5954L4.92015 11.2976L4.92016 11.2976L4.91894 11.2963C4.67999 11.0555 4.29763 11.0626 4.06707 11.3116L4.06706 11.3116C3.84431 11.5522 3.84432 11.9321 4.06705 12.1728L4.06704 12.1728L4.06825 12.1741L9.57222 17.9164L9.57223 17.9164C9.80699 18.1612 10.1894 18.1612 10.4241 17.9164L10.4241 17.9164L20.9317 6.95387L20.9329 6.95261C21.1612 6.70601 21.1548 6.31454 20.9182 6.07609L20.9182 6.07607C20.6852 5.84132 20.314 5.8413 20.081 6.07608Z" fill="white" stroke="white" stroke-width="0.2" stroke-linecap="square" stroke-linejoin="bevel"/>
                  </svg>
                </span>
              </div>
            </form>
      </div>
	  </div>
		
    <div class="slide-dec">
    <h4><a href="{{ du }}">{{dt}}</a></h4>
    <div class="price-wrap">
    <span class="price">{{cu}}{{pr}}</span>
    </div>
    </div>
	</div>
	</div>
       {{/products}}
	</div></div></div></div>`;



function getVariantInfo(variants) {
	try {
		let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
			variantinfo;
		if (variantKeys.length > 0) {
			variantinfo = variantKeys[0];
			if (variantinfo == "Default Title") {
				variantinfo = "";
			}
		} else {
			variantinfo = "";
		}
		return variantinfo;
	} catch (err) {
		return variants;
	}
}
if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {
	// Get wishlist items
	swat.fetch(function(products) {
		console.log(products)
		var wishlistContentsContainer = document.getElementById("wishlist-items-container");
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
			return p;
		});
		var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
			products: formattedWishlistedProducts
		});
		wishlistContentsContainer.innerHTML = productCardsMarkup;
		attachClickListeners();
	});
}

function onAddToCartClick(e) {
	e.preventDefault();
	var productId = e.currentTarget.getAttribute("data-product-id");
	var variantId = e.currentTarget.getAttribute("data-variant-id");
	var du = e.target.getAttribute("data-product-url");
	e.target.innerHTML = "Adding..";
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		e.target.innerHTML = "Added to Cart";
		e.target.setAttribute("data-state-cart", "swym-added");
		console.log("Successfully added product to cart.", c);
	}, function(e) {
		console.log(e);
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
	var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
	//   Add to cart Btns
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	//   Remove Buttons
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
	console.log("Events attached!");
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi) {
				window._swat.removeFromWishList(product, function() {
					if (!window.SwymCallbacks) {
						window.SwymCallbacks = [];
					}
					window.SwymCallbacks.push(swymRenderWishlist);
				});
			}
		});
	})
}